export const Machine = [
    { type: 'image', url: require('../../../assets/machine/10.webp') },
    { type: 'image', url: require('../../../assets/machine/11.webp') },
    { type: 'image', url: require('../../../assets/machine/22.jpg') },
    { type: 'image', url: require('../../../assets/machine/13.webp') },
    { type: 'image', url: require('../../../assets/machine/16.webp') },
    { type: 'image', url: require('../../../assets/machine/3.webp') },
    { type: 'image', url: require('../../../assets/machine/7.webp') },
    { type: 'image', url: require('../../../assets/machine/9.webp') },
    { type: 'image', url: require('../../../assets/machine/20.jpg') },
]